module.exports = __webpack_public_path__ + "img/fluid-wagon-2.fadfd5fc.png";